import axios from 'axios';
import { config } from 'dotenv';
import React, { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom';
config()

const Redirect = () => {
    const history = useHistory()
    let query = new URLSearchParams(useLocation().search)
    useEffect(() => {
       axios.get(`${process.env.REACT_APP_API_URL}/CoinbaseToken/?code=${query.get('code')}`).then(res => {
           console.log(res.data)
       })
       // eslint-disable-next-line
    }, [history])
    console.log(query.get('code'))
    return (
        <div>
           { query.get('code')}
        </div>
    )
}

export default Redirect
                                                                                                                                                                            